import React from 'react';
import { NetworkLanDTO, NetworkWanDTO } from '@webip/shared/src/dto/appliance';
import Grid, { GridItem } from '@/components/layout/Grid';
import CampoSeletor from '@/components/Formulario/CampoSeletor';
import { FormLan } from './FormLan';
import { FormWan } from './FormWan';

type NetworkType = 'lan' | 'wan' | 'ipsec';

type Props = {
    networkType: NetworkType | null;
    onChangeNetworkType: (type: NetworkType) => void;
    value: NetworkLanDTO | NetworkWanDTO | null;
    onChange: (value: NetworkLanDTO | NetworkWanDTO) => void;
    fieldErrors: Record<string, string>;
    availablePorts: string[];
    /** Appliance dona da rede — habilita o aviso de grupos RADIUS na VLAN da LAN. */
    applianceId?: number;
    /** LANs que podem servir de rede base (trunk) para uma VLAN — vazio desliga a opção. */
    lanBases?: NetworkLanDTO[];
    /** WANs para o link preferencial da LAN — undefined esconde o campo. */
    wans?: NetworkWanDTO[];
};

export const FormNetwork = ({
    networkType,
    onChangeNetworkType,
    value,
    onChange,
    fieldErrors,
    availablePorts,
    applianceId,
    lanBases,
    wans,
}: Props) => {
    // Se ainda não escolheu o tipo
    if (!networkType) {
        return (
            <Grid>
                <GridItem sm={12}>
                    <CampoSeletor
                        noSearch
                        label="Tipo de Rede"
                        value=""
                        onChange={(v) => onChangeNetworkType(v as NetworkType)}
                        options={[
                            { id: 'lan', label: 'LAN - Rede Local' },
                            { id: 'wan', label: 'WAN - Rede Externa' },
                            { id: 'ipsec', label: 'IPSec - Túnel VPN' },
                        ]}
                        error={fieldErrors?.tipo}
                    />
                </GridItem>
            </Grid>
        );
    }

    // Se escolheu LAN
    if (networkType === 'lan' && value) {
        return (
            <FormLan
                value={value as NetworkLanDTO}
                onChange={onChange as (v: NetworkLanDTO) => void}
                fieldErrors={fieldErrors}
                availablePorts={availablePorts}
                applianceId={applianceId}
                lanBases={lanBases}
                wans={wans}
            />
        );
    }

    // Se escolheu WAN
    if (networkType === 'wan' && value) {
        return (
            <FormWan
                value={value as NetworkWanDTO}
                onChange={onChange as (v: NetworkWanDTO) => void}
                fieldErrors={fieldErrors}
                availablePorts={availablePorts}
            />
        );
    }

    return null;
};
